if(!customElements.get('custom-scrollable-collections')){
    class CustomScrollableCollections extends HTMLElement {
        constructor(){
            super();

            this.init();
        }

        init(){
            this.swiperContainers = this.querySelectorAll('.swiper-container');
            this.collectionWrappers = this.querySelectorAll(".scrollable-collections__collection-products");
            this.swiperContainers.forEach(item => {
                const collectionWrapper = item.closest('.scrollable-collections__collection-products');
                collectionWrapper.setAttribute('data-active', 'true');
                collectionWrapper.style.visibility = 'hidden';
                collectionWrapper.style.opacity = '0';

                this.initSwiper(item);

                collectionWrapper.setAttribute('data-active', 'false');
                collectionWrapper.style.visibility = 'visible';
                collectionWrapper.style.opacity = '1';
            });

            this.sectionName = `.scrollable-collections[data-id="${this.dataset.id}"]`;
            var scrollingDuration = this.dataset.scrollingDuration;
            this.collectionSize = parseInt(this.dataset.collectionSize);
            if(this.collectionSize == 0) this.collectionSize = 1;
            if(scrollingDuration == 'normal'){
                this.scrollingDuration = `${100 * this.collectionSize}%`;
            }else if(scrollingDuration == 'shorter'){
                this.scrollingDuration = `${80 * this.collectionSize}%`;
            }else{
                this.scrollingDuration = `${150 * this.collectionSize}%`;
            }
            this.initParallaxScrollAnimation();
        }


        refresh(){
            if (this.controller) {
                this.controller.destroy(true); 
                this.controller = null; 
            }
            
            if (this.scene) {
                this.scene.destroy(true);
                this.scene = null;
            }
            this.init();
        }

        initSwiper(swiperContainer){
            var totalSlides = parseInt(swiperContainer.dataset.totalSlides);
            var numPerView = 4;
            var slidesPerView = (numPerView && totalSlides > numPerView)? numPerView : totalSlides;
            var loop = (swiperContainer.dataset.loop == 'true')? true : false;
            if(totalSlides == 1) loop = false;

            var swiperSettings = {
                init: true,
                initialSlides: 0,
                loop: loop,
                spaceBetween: 30,
                centeredSlides: false,
                speed: 500,
                watchOverflow: true,
                breakpoints: {
                    0: {
                        slidesPerView: 1
                    },
                    567: {
                        slidesPerView: slidesPerView < 2? slidesPerView : 2
                    }
                },
                observer: true,
                observeSlideChildren: true
            }

            let productsWrapper = swiperContainer.closest('.scrollable-collections__collection-products');
            if(productsWrapper.querySelector('.swiper-pagination')){
                swiperSettings.pagination = {
                    el: productsWrapper.querySelector('.swiper-pagination')
                }
            }

            if(productsWrapper.querySelector('.swiper-button-next')){
                swiperSettings.navigation = {
                    nextEl: productsWrapper.querySelector('.swiper-button-next'),
                    prevEl: productsWrapper.querySelector('.swiper-button-prev')
                }
            }

            if(swiperContainer.dataset.autoplay == 'true'){
                let speed = swiperContainer.dataset.speed;
                speed = parseInt(speed) * 1000;
                swiperSettings.autoplay = {
                    delay: speed
                }
            }

            const swiper = new Swiper(swiperContainer, swiperSettings);
            this.getVisibleSlides(swiper);

            swiper.on('slideChange', () => {
                this.getVisibleSlides(swiper);
            });
        }

        getVisibleSlides(swiper){
            if(swiper){
                const allSlides = swiper.slides;
                const activeIndex = swiper.activeIndex;
                const slidesPerView = swiper.params.slidesPerView;

                const visibleSlides = [];
                
                if(slidesPerView === 'auto'){
                    allSlides.forEach((slide) => {
                        const rect = slide.getBoundingClientRect();
                        if (rect.left >= 0 && rect.right <= window.innerWidth) {
                            visibleSlides.push(slide);
                        }
                    });
                }else{
                    for (let i = activeIndex; i < activeIndex + slidesPerView && i < allSlides.length; i++) {
                        visibleSlides.push(allSlides[i]);
                    }
                }
    
                allSlides.forEach((slide) => {
                    slide.querySelectorAll('.tab-able-item').forEach((item) => {
                        item.setAttribute('tabindex', '-1');
                    });
                });
    
                visibleSlides.forEach((slide) => {
                    slide.querySelectorAll('.tab-able-item').forEach((item) => {
                        item.setAttribute('tabindex', '0');
                    });
                });
            }
        }

        initParallaxScrollAnimation(){
            const tween = new TimelineLite();

            this.collectionWrappers.forEach((item, idx) => {
                if(idx !== 0){
                    tween.add(TweenLite.fromTo(item, 0, {
                        opacity: 0,
                        attr: { "data-active": "false" }
                    }, {
                        opacity: 1,
                        attr: { "data-active": "true" }
                    }));

                    tween.add(TweenLite.to(this.collectionWrappers[idx - 1], 0.0001, {
                        opacity: 0,
                        attr: { "data-active": "false" }
                    }), "<");

                    tween.add(TweenLite.to(this.querySelector(`.scrollable-collections__pagination-bullet[data-idx="${parseInt(item.dataset.idx) - 1}"]`), 0.1, {
                        height: '10px'
                    }), "<");

                    if(this.querySelectorAll(`.scrollable-collections__name-wrapper[data-idx="${parseInt(item.dataset.idx) - 1}"]`).length > 0){
                        tween.add(TweenLite.to(this.querySelector(`.scrollable-collections__name-wrapper[data-idx="${parseInt(item.dataset.idx) - 1}"]`), 0.0001, {
                            attr: { "data-active": "false" }
                        }), "<");
                    }

                    if(this.querySelectorAll(`.scrollable-collections__name-wrapper[data-idx="${parseInt(item.dataset.idx) - 1}"] .body-text`).length > 0){
                        tween.add(TweenLite.to(this.querySelector(`.scrollable-collections__name-wrapper[data-idx="${parseInt(item.dataset.idx) - 1}"] .body-text`), 0.0001, {
                            opacity: 0,
                            visibility: "hidden",
                            height: 0
                        }), "<");
                    }


                    if(this.querySelectorAll(`.scrollable-collections__name-wrapper[data-idx="${item.dataset.idx}"]`).length > 0){
                        tween.add(TweenLite.fromTo(this.querySelector(`.scrollable-collections__name-wrapper[data-idx="${item.dataset.idx}"]`), 0.0001, {
                            attr: { "data-active": "false" }
                        }, {
                            attr: { "data-active": "true" }
                        }), "<");
                    }

                    if(this.querySelectorAll(`.scrollable-collections__name-wrapper[data-idx="${item.dataset.idx}"] .body-text`).length > 0){
                        tween.add(TweenLite.fromTo(this.querySelector(`.scrollable-collections__name-wrapper[data-idx="${item.dataset.idx}"] .body-text`), 0.0001, {
                            opacity: 0,
                            visibility: "hidden",
                            height: 0
                        }, {
                            opacity: 1,
                            visibility: "visible",
                            height: "auto"
                        }), "<");
                    }

                    tween.add(TweenLite.fromTo(this.querySelector(`.scrollable-collections__pagination-bullet[data-idx="${item.dataset.idx}"]`), 0.3, {
                        height: '10px'
                    }, {
                        height: '30px'
                    }), "<");

                }else{
                    tween.add(TweenLite.fromTo(item, 0, {
                        opacity: 1,
                        attr: { "data-active": "true" }
                    }, {
                        opacity: 1,
                        attr: { "data-active": "true" }
                    }));

                    
                    if(this.querySelectorAll(`.scrollable-collections__name-wrapper[data-idx="${item.dataset.idx}"]`).length > 0){
                        tween.add(TweenLite.fromTo(this.querySelector(`.scrollable-collections__name-wrapper[data-idx="${item.dataset.idx}"]`), 0.0001, {
                            attr: { "data-active": "true" }
                        }, {
                            attr: { "data-active": "true" }
                        }), "<");
                    }

                    if(this.querySelectorAll(`.scrollable-collections__name-wrapper[data-idx="${item.dataset.idx}"] .body-text`).length > 0){
                        tween.add(TweenLite.fromTo(this.querySelector(`.scrollable-collections__name-wrapper[data-idx="${item.dataset.idx}"] .body-text`), 0.0001, {
                            opacity: 1,
                            visibility: "visible",
                            height: "auto"
                        }, {
                            opacity: 1,
                            visibility: "visible",
                            height: "auto"
                        }), "<");
                    }

                    tween.add(TweenLite.fromTo(this.querySelector(`.scrollable-collections__pagination-bullet[data-idx="${item.dataset.idx}"]`), 0.3, {
                        height: '30px'
                    }, {
                        height: '30px'
                    }), "<");
                }

                
            });

            this.controller = new ScrollMagic.Controller();

            this.scene = new ScrollMagic.Scene({
                triggerElement: `${this.sectionName}`,
                duration: this.scrollingDuration,
                triggerHook: 0
            });

            this.scene.setTween(tween)
            .setPin(`${this.sectionName}`)
            .addTo(this.controller);
        }
    }

    customElements.define('custom-scrollable-collections', CustomScrollableCollections);
}